var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92 8H15.36V2H1.92V8ZM17.28 1V17C17.28 17.28 17.1872 17.5167 17.0016 17.71C16.816 17.9033 16.5888 18 16.32 18H0.96C0.6912 18 0.464 17.9033 0.2784 17.71C0.0928 17.5167 0 17.28 0 17V1C0 0.720001 0.0928 0.483334 0.2784 0.290001C0.464 0.0966663 0.6912 0 0.96 0H16.32C16.5888 0 16.816 0.0966663 17.0016 0.290001C17.1872 0.483334 17.28 0.720001 17.28 1ZM15.36 10H1.92V16H15.36V10ZM3.84 12H6.72V14H3.84V12ZM3.84 4H6.72V6H3.84V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/DocumentIcon.bd46af8b1742d20d27cc5c2c74d2db10.svg";
export { ForwardRef as ReactComponent };